export enum PowerEnum {
  ExtraWall = 'ExtraWall',
  ShortestPath = 'ShortestPath',
  BlockMove = 'BlockMove',
  Undo = 'Undo',
}
